import { isEqual } from "lodash";
import { useState, useCallback } from "react";

import { IncomingMailStatusRef } from "src/models/incoming-mail-status";
import { IncomingMailStatusDTO } from "src/models/incoming-mail-status/incoming-mail-status-dto";
import { MailClassificationStatusDTO } from "src/models/mail-classification-status";
import { MailClassificationStatusQuickFilter } from "./interfaces";

export const useMailClassificationStatusQuickFilter = (defaultValue?: IncomingMailStatusRef[]) => {
  const [quickFilter, setQuickFilter] = useState<MailClassificationStatusQuickFilter>({
    mailClassificationStatuses: {
      mailClassificationStatusIds: defaultValue ? [...defaultValue.map((item) => item.id)] : [],
    },
  });

  const [selectedMailClassificationStatus, setSelectedMailClassificationStatus] =
    useState<MailClassificationStatusDTO | null>(null);

  const handleChangeQuickFilter = useCallback(
    (
      filter: keyof MailClassificationStatusQuickFilter,
      value: MailClassificationStatusQuickFilter["mailClassificationStatuses"],
      item: IncomingMailStatusDTO | null
    ) => {
      if (isEqual(value, quickFilter[filter])) return;

      setQuickFilter((state) => ({ ...state, [filter]: value }));
      setSelectedMailClassificationStatus(item);
    },
    [quickFilter]
  );

  return {
    mailClassificationStatusQuickFilter: quickFilter,
    setMailClassificationStatusQuickFilter: handleChangeQuickFilter,
    selectedMailClassificationStatus,
  };
};
